import React from 'react'
import { Switch } from '@headlessui/react'

const sizes = {
  sm: {
    container: 'h-5 w-9',
    thumb: 'h-4 w-4',
    translate: 'translate-x-4',
  },
  md: {
    container: 'h-6 w-11',
    thumb: 'h-5 w-5',
    translate: 'translate-x-5',
  },
  lg: {
    container: 'h-7 w-14',
    thumb: 'h-6 w-6',
    translate: 'translate-x-7',
  },
}

const ToggleSwitch = ({
  label,
  description,
  checked = false,
  onChange = () => {},
  disabled = false,
  size = 'md',
  className = '',
  labelPosition = 'left',
}) => {
  const sizeStyles = sizes[size] ?? sizes.md
  const resolvedLabelPosition = ['left', 'right'].includes(labelPosition)
    ? labelPosition
    : 'left'
  const showLabel = Boolean(label)

  return (
    <Switch.Group
      as="div"
      className={`flex items-center gap-3 ${resolvedLabelPosition === 'right' ? 'flex-row-reverse' : ''} ${className}`}
    >
      {showLabel ? (
        <div className="flex flex-col">
          <Switch.Label className="text-sm font-medium text-customBlack/80 dark:text-white/80">
            {label}
          </Switch.Label>
          {description ? (
            <span className="text-xs text-customBlack/50 dark:text-white/50">
              {description}
            </span>
          ) : null}
        </div>
      ) : null}

      <Switch
        checked={checked}
        onChange={disabled ? () => {} : onChange}
        disabled={disabled}
        className={`relative inline-flex shrink-0 cursor-pointer rounded-full border transition-colors duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-customAccent focus-visible:ring-offset-2 focus-visible:ring-offset-white dark:focus-visible:ring-offset-customSurface
          ${sizeStyles.container}
          ${checked ? 'bg-customAccent border-customAccent' : 'bg-slate-200 border-slate-200 dark:bg-white/10 dark:border-white/10'}
          ${disabled ? 'cursor-not-allowed opacity-50' : ''}
        `}
      >
        <span
          aria-hidden="true"
          className={`pointer-events-none inline-block transform rounded-full bg-white shadow transition duration-200 ease-in-out ${sizeStyles.thumb} ${
            checked ? sizeStyles.translate : 'translate-x-1'
          }`}
        />
      </Switch>
    </Switch.Group>
  )
}

export default ToggleSwitch
